export default "__VITE_ASSET__CEwjtcn0__"